module.exports = __webpack_public_path__ + "img/tledu-web-front-end-advantage.d70aeeeb.png";